var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 38.8,
    viewBox: "0 0 30 38.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.859,0H55V38.8H85V7.561ZM78.2,2.109,83.008,7.2H78.2ZM83.8,37.6H56.2V1.2H77V8.4h6.8Z",
    transform: "translate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.4,
    height: 1.2,
    transform: "translate(3.8 15.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.6,
    height: 1.2,
    transform: "translate(3.8 11.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.4,
    height: 1.2,
    transform: "translate(3.8 19.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.4,
    height: 1.2,
    transform: "translate(3.8 23.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.4,
    height: 1.2,
    transform: "translate(3.8 27.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.4,
    height: 1.2,
    transform: "translate(3.8 31.28)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/iconDocument.6043913caf9e91e21612a402cd3f3b28.svg";
export { ForwardRef as ReactComponent };